var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-16px col-lg-6 mt-3"},[_c('i',{staticClass:"tio-add-circle color-yellow tio-xl",staticStyle:{"vertical-align":"bottom"}}),_vm._v(" "+_vm._s(_vm.$t('add_member'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }